import React from 'react';
import { Navigate } from 'react-router-dom';

const BasicProfileCheck = ({ children }) => {
  const isBasicProfileDone = JSON.parse(localStorage.getItem('isBasicProfileDone'));

  if (!isBasicProfileDone) {
    return <Navigate to="/basic-registration" />;
  
  }
  return children;
};

export default BasicProfileCheck;
